import React from 'react';
import './KitchenDashboard.css';

// Kuhinja (kuvari) - prazan dashboard, predviđen za buduće panele kuhinje.
const KitchenDashboard = () => (
  <div className="kitchen-dashboard">
    {/* Zasad prazno - mesto za buduće panele kuvara. */}
  </div>
);

export default KitchenDashboard;
